import { api } from './api';

export type DataExportResponse = {
  message: string;
};

/** Requests an archive of the authenticated account's Paçoca data by email. */
export const requestAccountDataExport = (token: string) =>
  api(token).post<DataExportResponse>('/data-export');
